<template>
    <div
        id="app"
        class="App"
    >
        <RouterView />
    </div>
</template>
<style lang="scss">
    @import '@/styles/quasar.legacy.scss';
</style>
<style lang="scss">
    @use '@/styles/_globals.scss' as *;
</style>
